import { render, staticRenderFns } from "./AdminModel.vue?vue&type=template&id=c09ff6b8&scoped=true&"
import script from "./AdminModel.vue?vue&type=script&lang=js&"
export * from "./AdminModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09ff6b8",
  null
  
)

export default component.exports